import { LogoFooter } from './LogoFooter';

export default LogoFooter;
